import GameParameterInterface from '@/models/game/parameters/interface'
import { Property } from '@/models/game/property'
import GameExecutorInterface from '@/services/game/executor/executor-interface'
import GameProcessor from '@/services/game/processor'
import { ScriptLoader } from '@/util/scriptLoader'

export default class JankenGameExecutor implements GameExecutorInterface {

  constructor(
    private processor: GameProcessor,
    private property: Property,
    private parameter: GameParameterInterface
  ) { }

  async execute(): Promise<void> {

    const scriptLoader = new ScriptLoader({
      src : this.property.scriptUrl,
      global: 'GAME',
    })

    const game: any = await scriptLoader.load()

    const option = this.parameter.createSetOption()
    const margeOption = {
      ...option,
      prize: {
        ...option.prize,
        guideUrl: this.processor.makeGameResultUrl(),
      },
    }

    game.setOption({
      ...margeOption,
      resource: this.property.resourcePath,
      game: 'janken',
      theme: this.property.theme,
      challengeLimit: this.property.challengeLimit,
    })
    .setStarted(() => {

      if (!this.processor.playStatusIsStarted) {
        return this.processor.notifyGameStart({})
      }

      return Promise.resolve()
    })
    .setCompleted(() => {

      return this.processor.notifyGameComplete()
    })
    .start()
  }
}
